import './index.less';
import { Popconfirm } from 'antd';

import { DeleteIcon } from 'components/Icons';
import { UnderlineText } from 'components/RevxTypography';
import { getFileType } from 'utils/misc';
import React from 'react';
import { getFileIcon, getFilePath } from 'utils/file';
import { FileItem } from 'domains/workspaceDetailDomain';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';

type Props = {
  fileItem: FileItem;
  onDelete?: () => void;
};
export const FileLink = ({ fileItem, onDelete }: Props) => {
  const fileType = getFileType(fileItem.fileName);
  const { t } = useTranslation();
  return (
    <span className="file-link">
      <span className="revx-icon-con" style={{ color: '#FC5A5A' }}>
        {getFileIcon(fileType)}
      </span>
      <a
        target="_blank"
        rel="noreferrer"
        download={fileItem.fileName}
        href={getFilePath(fileItem)}
        className="file-link-a"
      >
        <Tooltip title={fileItem.fileName}>
          <UnderlineText
            color="blue"
            size="small"
            style={{ width: 90 }}
            ellipsis
          >
            {fileItem.fileName}
          </UnderlineText>
        </Tooltip>
      </a>

      {onDelete && (
        <Popconfirm
          placement="topRight"
          title={t('common.confirmQuestion')}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => {
            if (onDelete) {
              onDelete();
            }
          }}
          okText={t('common.ok')}
          cancelText={t('common.cancel')}
        >
          <DeleteIcon className="file-link-delete" />
        </Popconfirm>
      )}
    </span>
  );
};
